/**
 * Investors layout route - renders child routes (list, detail)
 */

import { Outlet } from '@tanstack/react-router'

export const Route = createFileRoute({
  component: InvestorsLayout,
})

function InvestorsLayout() {
  return <Outlet />
}
